/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Modal, notification } from "antd";
import { useState } from "react";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import classNames from "classnames";
import { v4 as uuidv4 } from "uuid";

import { ME, FETCH_CLASS, REMAKE_PAYMENT, UPDATE_CHECKOUT_STATUS } from "./graphql";
import style from "./style.module.scss";

import { Arrow } from "../../components/Arrow";
import { Clock } from "../../assets/Clock";
import Close from "../../assets/close.svg";
import { Diploma } from "../../assets/diploma";
import { Institution } from "../../assets/institution";
import { Local } from "../../assets/local";
import { Remoticity } from "../../assets/remoticity";
import { Semester } from "../../assets/semester";
import { University } from "../../assets/university";
import { Loading } from "../../components/Loading";
import { TransactionStatusWithAction } from "../../components/TransactionStatusWithAction";

// import { DurationType, OrderData, PaymentMethod, StudentEnrollmentStatus, TransactionStatus } from "../../generated/globalTypes";
// import { MeMyAccount } from "../../generated/MeMyAccount";
// import { remakePayment } from "../../generated/remakePayment";
// import { updateCheckoutStatus } from "../../generated/updateCheckoutStatus";
import {
	cashbackStatusLabels,
	classShiftLabels,
	classTypeLabels,
	formatDuration,
	getClassDescPagePath,
	graduationTypeLabels,
	levelLabels,
} from "../../utils/formatters";
import { createEvent } from "../../vendor/eventTracker";
import { useRouter } from "next/router";
import Link from "next/link";

import { useAuthApollo } from "@lib/apolloClientConfig";

enum DurationType {
	Horas = "Horas",
	Meses = "Meses",
	Semestres = "Semestres",
}

enum TransactionStatus {
	authorized = "authorized",
	canceled = "canceled",
	error = "error",
	expired = "expired",
	paid = "paid",
	pending_refund = "pending_refund",
	processing = "processing",
	refunded = "refunded",
	refused = "refused",
	waiting_payment = "waiting_payment",
}

interface IUserCheckouts {
	courseName?: string;
	courseSlug?: string;
	courseId?: string;
	level?: string;
	classType?: string;
	institutionName?: string;
	institutionSlug?: string;
	institutionLogo?: string | null;
	addressCity?: string;
	addressState?: string;
	graduationType?: string;
	duration?: number;
	durationType?: DurationType;
	spot?: number;
	typeButton: "together" | "separate";
	shift?: string;
	campusName?: string;
	id?: string;
	classId?: string;
	refetch: () => void;
	visiblePopover?: () => void;
	transactionStatus?: TransactionStatus;
	boletoUrl: string | null;
	styleInline?: React.CSSProperties;
	type: "default" | "visible";
	boletoExpirationDate?: Date;
	classOriginalPrice: number;
	classDiscount: number;
	classPriceOriginalPrice: number | null | undefined;
	classPriceDiscount: number | null | undefined;
	setWasScrolled: React.Dispatch<React.SetStateAction<boolean>>;
	wasScrolled: boolean;
	isMatriculae?: boolean;
	enrollmentStatus?: string | null;
}

const CardInterests: React.FC<IUserCheckouts> = ({
	courseName,
	courseSlug,
	courseId,
	level,
	classType,
	institutionName,
	institutionSlug,
	institutionLogo,
	addressCity,
	addressState,
	graduationType,
	duration,
	durationType,
	spot,
	typeButton,
	campusName,
	styleInline,
	shift,
	id,
	classId,
	refetch,
	transactionStatus,
	visiblePopover,
	boletoUrl,
	type,
	boletoExpirationDate,
	classOriginalPrice,
	classDiscount,
	classPriceOriginalPrice,
	classPriceDiscount,
	setWasScrolled,
	wasScrolled,
	isMatriculae,
	enrollmentStatus,
}) => {
	const [infos, setInfos] = useState(false);
	const [rotate, setRotate] = useState(false);
	const [visibleModal, setVisibleModal] = useState(false);
	const history = useRouter();
	const [regenerateBoletoLoading, setRegenerateBoletoLoading] = useState(false);

	const client = useAuthApollo({ initialState: {} });

	const handleMenu = (arg: any) => {
		setVisibleModal(true);
		arg();
		if (visiblePopover) {
			visiblePopover();
		}
	};

	const handleOk = () => {
		setVisibleModal(false);
	};

	const handleCancel = () => {
		setVisibleModal(false);
	};

	const [handleUpdateCheckoutStatus, { loading }] = useMutation(UPDATE_CHECKOUT_STATUS, {
		onCompleted: (res) => {
			if (res.updateCheckoutStatus) {
				refetch();
				setVisibleModal(false);
				notification.success({
					message: "Contratação apagada com sucesso",
				});
			} else {
				notification.error({
					message: "Houve um erro em apagar a contratação. Tente novamente em breve",
				});
			}
		},
		variables: {
			checkoutId: id,
			isActive: false,
		},
		client,
	});

	const handleContinue = (e: React.MouseEvent) => {
		e.preventDefault();
		createEvent("clicked_continue_checkout_my_interests");
		if (visiblePopover) {
			visiblePopover();
		}
		history.push(`/inscricao/${classId}`);
	};

	const handleDelete = () => {
		handleUpdateCheckoutStatus();
	};

	const handleSearch = (e: React.MouseEvent) => {
		e.preventDefault();
		history.push(
			`/busca?city=${addressCity}&courseName=${courseName}&courseId=${courseId}&sid=${uuidv4()}&source=${
				window.location.pathname === "/busca" ? "search_page" : "home"
			}&level[]=${level}&page=1`,
		);
	};

	const showClassOfferChanged = (() => {
		if (transactionStatus && ["paid", "waiting_payment"].includes(transactionStatus)) {
			return false;
		}

		return classPriceOriginalPrice !== classOriginalPrice || classPriceDiscount?.toFixed(2) !== classDiscount.toFixed(2);
	})();

	const showClassOfferNotAvailable = (() => {
		if (transactionStatus && ["paid", "waiting_payment"].includes(transactionStatus)) {
			return false;
		}
		return spot === 0;
	})();

	const modal = (
		<Modal title="Apagar contratação" className={style.modalHiring} visible={visibleModal} onOk={handleOk} onCancel={handleCancel} footer={null}>
			<p>Você deseja apagar a contratação desta bolsa?</p>
			{loading ? (
				<Loading />
			) : (
				<>
					<div className={style.content}>
						<h2>{courseName}</h2>
						<p>
							{levelLabels[level!]}, {classTypeLabels[classType!]}
						</p>
						<p>
							{campusName}, {classShiftLabels[shift!]}
						</p>

						<figure>
							<University />
							<span>{institutionName}</span>
						</figure>
					</div>

					<p>Caso mude de ideia no futuro, você pode procurar novamente por essa bolsa aqui no Amigo Edu, caso ainda haja vagas.</p>

					{typeButton === "separate" ? (
						<div className={style.groupButtons}>
							<button
								className={style.btnBack}
								onClick={() => {
									setVisibleModal(false);
								}}
							>
								<span>Voltar</span>
							</button>
							<button className={style.btnDelete} onClick={handleDelete}>
								<Close className={style.icon} />
								<span>Apagar</span>
							</button>
						</div>
					) : (
						<div className={[typeButton === "together" && style.together, style.btnDelete].join(" ")} onClick={handleDelete}>
							<Close className={style.icon} />
							<span>Apagar</span>
						</div>
					)}
				</>
			)}
		</Modal>
	);

	const { data: dataMe } = useQuery(ME, { client });

	const [handleRemakePayment] = useMutation(REMAKE_PAYMENT, {
		onCompleted: (dataRemakePayment) => {
			if (dataRemakePayment?.payment.success) {
				notification.success({
					description: "Seu novo boleto foi gerado.",
					message: "Boleto gerado",
				});
			} else {
				notification.error({
					description: dataRemakePayment?.payment.message,
					message: "Erro",
				});
			}
		},
		client,
	});

	const paymentRemake = async (value: number, classIdArg: string) => {
		const personalData = dataMe?.me;

		if (!personalData || regenerateBoletoLoading) {
			return;
		}

		setRegenerateBoletoLoading(true);

		const orderData = {
			cardHash: null,
			city: personalData.addressCity!,
			classId: classIdArg,
			neighborhood: personalData.addressNeighborhood!,
			paymentMethod: "boleto",
			state: personalData.addressUF!,
			street: personalData.addressStreet!,
			streetNumber: personalData?.addressNumber?.toString(),
			value,
			zipcode: personalData?.addressZipCode?.replace(/[^0-9.]/g, ""),
		};

		await handleRemakePayment({ variables: { orderData } });

		setRegenerateBoletoLoading(false);
		refetch();
	};

	const [getClass] = useLazyQuery(FETCH_CLASS, {
		onCompleted: (data) => {
			if (data) {
				paymentRemake(data.class.purchasePrice, data.class.id);
			}
		},
		client,
	});

	const generatedBoleto = () => {
		getClass({
			variables: {
				classId,
			},
		});
	};

	const handleViewBoleto = () => {
		window.open(boletoUrl!, "_blank");
	};

	const transactionActions = {
		expired: generatedBoleto,
		handleContinue,
		handleMenu,
		handleSearch,
		handleViewBoleto,
		paid: null,
	};

	const messageTransaction = {
		expired: "Ainda não recebemos o pagamento da taxa de matrícula e o boleto gerado já venceu.",
		paid: "Recebemos o seu pagamento da pré-matrícula e a sua vaga já está reservada!",
		pending: "Evite a perda da sua vaga, conclua agora mesmo o processo clicando no botão abaixo:",
		waiting_payment: "Estamos aguardando o recebimento da taxa de matrícula. O pagamento por boleto leva até 2 dias úteis para ser faturado.",
	};

	return (
		<>
			<div className={style.cardInterest} style={styleInline} onWheel={() => setWasScrolled(true)}>
				<div>
					<Link href={getClassDescPagePath(institutionSlug!, courseSlug!, classId!)}>
						<a onClick={visiblePopover}>
							<h2
								className={classNames({
									[style.opacity]: showClassOfferNotAvailable,
								})}
							>
								{courseName}
							</h2>
						</a>
					</Link>
					<div
						className={classNames(style.arrow, { [style.rotate]: rotate })}
						onClick={() => {
							setRotate(!rotate);
							setInfos(!infos);
						}}
						style={{ cursor: "pointer" }}
					>
						<Arrow className={style.icon} />
					</div>
				</div>
				<div
					className={classNames(style.info, {
						[style.opacity]: showClassOfferNotAvailable,
					})}
				>
					{infos ? (
						<div className={style.col}>
							<figure>
								<Diploma color="#A6A1A1" />
								{graduationType && <span>{graduationTypeLabels[graduationType]}</span>}
							</figure>
							{duration && (
								<figure>
									<Semester color="#A6A1A1" />
									<span>
										{duration} {formatDuration(duration, durationType!).toLowerCase()}
									</span>
								</figure>
							)}
							{classType && (
								<figure>
									<Remoticity className={style.icon} />
									<span>{classTypeLabels[classType]}</span>
								</figure>
							)}
						</div>
					) : (
						<p>
							{levelLabels[level!]}, {classTypeLabels[classType!]}
						</p>
					)}
				</div>
				<figure
					className={classNames(style.info, {
						[style.opacity]: showClassOfferNotAvailable,
					})}
				>
					<picture>{institutionLogo ? <img loading="lazy" src={institutionLogo} alt={institutionName} /> : <Institution />}</picture>
					<figcaption>
						<p className={style.institutionName}>{institutionName}</p>
						<p className={style.localization}>
							{addressCity} - {addressState}
						</p>
					</figcaption>
				</figure>
				{infos && (
					<div
						className={classNames(style.info, style.group, {
							[style.opacity]: showClassOfferNotAvailable,
						})}
					>
						<div className={style.col}>
							<figure>
								<div className={style.icon}>
									<Local fill="#807D7D" />
								</div>
								<span>{campusName}</span>
							</figure>
						</div>

						<div className={style.col}>
							<figure>
								<Clock />
								<span>{classShiftLabels[shift!]}</span>
							</figure>
						</div>
					</div>
				)}
				{!showClassOfferNotAvailable && showClassOfferChanged && (
					<div className={style.message}>Essa oferta sofreu uma alteração no valor.</div>
				)}
				{showClassOfferNotAvailable && <div className={style.message}>Essa oferta expirou e não está mais disponível.</div>}

				<TransactionStatusWithAction
					status={transactionStatus!}
					helper={cashbackStatusLabels}
					action={transactionActions}
					message={messageTransaction}
					showMessage={infos}
					loading={regenerateBoletoLoading}
					type={type}
					boletoExpirationDate={boletoExpirationDate}
					expiredOffer={showClassOfferNotAvailable}
					spot={spot}
					setWasScrolled={setWasScrolled}
					wasScrolled={wasScrolled}
					isMatriculae={isMatriculae}
					enrollmentStatus={enrollmentStatus}
					classId={classId!}
				/>
			</div>
			{modal}
		</>
	);
};

export default CardInterests;
